(() => {
  const selector = '[data-product-info-accordions]';
  const groupSelector = '[data-product-info-accordion-group]';

  function showAccordionsForVariant(container, variantId) {
    const groups = Array.from(container.querySelectorAll(groupSelector));
    const variantGroup = groups.find(
      (group) =>
        group.dataset.accordionSource === 'variant' &&
        group.dataset.variantId === String(variantId)
    );
    const productGroup = groups.find(
      (group) => group.dataset.accordionSource === 'product'
    );

    groups.forEach((group) => {
      group.hidden = true;
    });

    if (variantGroup) {
      variantGroup.hidden = false;
    } else if (productGroup) {
      productGroup.hidden = false;
    }
  }

  function initializeAccordions(root = document) {
    root.querySelectorAll(selector).forEach((container) => {
      showAccordionsForVariant(container, container.dataset.selectedVariantId);
    });
  }

  document.addEventListener('variant-changed', (event) => {
    const variantId = event.detail && event.detail.variantId;
    if (!variantId) return;

    document.querySelectorAll(selector).forEach((container) => {
      showAccordionsForVariant(container, variantId);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    initializeAccordions();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeAccordions(event.target);
  });
})();
